var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailureRedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 16C32.5 24.8366 25.3366 32 16.5 32C7.66344 32 0.5 24.8366 0.5 16C0.5 7.16344 7.66344 0 16.5 0C25.3366 0 32.5 7.16344 32.5 16ZM13.8875 11.5017L12.9447 10.5589L11.059 12.4445L12.0019 13.3873L14.6146 16.0001L12.0019 18.6128L11.059 19.5556L12.9447 21.4412L13.8875 20.4984L16.5002 17.8857L19.113 20.4984L20.0558 21.4412L21.9414 19.5556L20.9986 18.6128L18.3858 16.0001L20.9986 13.3873L21.9414 12.4445L20.0558 10.5589L19.113 11.5017L16.5002 14.1144L13.8875 11.5017Z",
    fill: "#E6204F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureRedCircle);
export default __webpack_public_path__ + "static/media/failure-red-circle.5240c852194ed814a1d198ef711b676c.svg";
export { ForwardRef as ReactComponent };